export const MULTIPART_FORM_DATA = {'Content-Type': 'multipart/form-data'};
